import { color } from './base/variables/color';

export const theme = {
  color,
};
